export const maxFilesizeMB = 10 // MB

export const mimes = [
	'image/png',
	'image/bmp',
	'image/gif',
	'image/jpeg',
	'image/jpg',
	'image/psf',
	'image/tif',
	'image/tiff',

	'text/csv',
	'application/msword', // doc
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
	'text/plain',
	'text/rtf',
	'application/pdf',
	'application/x-mspublisher',
	'application/vnd.sealed.mht', // MHT,
	'message/rfc822', // eml
	'application/vnd.ms-works', // WPS
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
	'application/vnd.ms-excel', // XLS, XLT
	'application/vnd.openxmlformats-officedocument.spreadsheetml.template', //XLTX
	'application/vnd.ms-xpsdocument',
	'text/html',
	'application/vnd.oasis.opendocument.spreadsheet', //ODS
	'application/vnd.oasis.opendocument.text', // ODT
	'application/x-font-pcf', // PCF
	'application/zip' // ZIP
]



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/data/allowed-attachments.js